import {
  FETCH_POPUPS_REQUEST,
  FETCH_POPUPS_SUCCESS,
  FETCH_POPUPS_FAILURE,
} from "../actions/popupActions";

const initialState = {
  popups: [],
  loading: false,
  error: null,
};

const popupReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_POPUPS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_POPUPS_SUCCESS:
      return { ...state, popups: action.payload, loading: false, error: null };
    case FETCH_POPUPS_FAILURE:
      return { ...state, popups: [], loading: false, error: action.payload };
    default:
      return state;
  }
};

export default popupReducer;

